module.exports = __webpack_public_path__ + "static/media/footer-accueil.3c0bfb1a.png";